import { create } from "zustand"
import { AppConfig } from "../api/types"

interface AppConfigStore {
  appConfig: AppConfig
  setAppConfig: (appConfig: AppConfig) => void
}

export const useAppConfigStore = create<AppConfigStore>()((set) => ({
  appConfig: {
    feature_flags: {
      above_ebitda_modules: {
        twc: true,
        fixed_assets: true,
        vat: true,
        taxes: true,
        provisions: true,
        other_working_capital: true,
        capital_structure: true,
      },
    },
  },
  setAppConfig: (appConfig) => set({ appConfig }),
}))
